module.exports = __webpack_public_path__ + "static/media/texture50.1c011657.png";